import { HistoricoStatusCondicaoEspecialDto } from 'src/servicos/api/condicao-especial'

/** Ações do histórico que não são troca de status (AcaoAuditoria no backend). */
export const AcaoHistoricoCondicaoEspecial = {
  AlteracaoStatus: 'AlteracaoStatus',
  PropostaEditada: 'PropostaEditada',
  ConviteEnviado: 'ConviteEnviado'
} as const

const VAZIO = '—'

export interface LinhaHistorico {
  titulo: string
  /** Quem fez, quando houver. */
  autor?: string
  observacao?: string
}

/**
 * Texto de cada item do histórico.
 *
 * Troca de status: "Anterior → Novo". Edição: "Campo: antes → depois" (um item por
 * campo, como o backend registra). Convite: "Convite enviado para x@y". O que mudou
 * vem nas colunas do registro — a observação só aparece quando existe.
 */
export const descreverItemHistorico = (
  item: HistoricoStatusCondicaoEspecialDto
): LinhaHistorico => {
  const autor = item.usuarioNome || undefined

  if (item.acao === AcaoHistoricoCondicaoEspecial.PropostaEditada) {
    const campo = item.campoPorExtenso ?? item.campo ?? 'Campo'

    return {
      titulo: `${campo}: ${item.valorAnterior ?? VAZIO} → ${item.valorNovo ?? VAZIO}`,
      autor,
      observacao: item.observacao
    }
  }

  if (item.acao === AcaoHistoricoCondicaoEspecial.ConviteEnviado) {
    return {
      titulo: `Convite enviado para ${item.valorNovo ?? VAZIO}`,
      autor,
      observacao: item.observacao
    }
  }

  // Prefixo "anterior →" aparece quando há QUALQUER informação do status
  // anterior — seja o enum cru (statusAnterior) ou só o texto
  // (statusAnteriorPorExtenso). Antes dependia só do enum cru, e um registro
  // que trouxesse apenas o texto saía sem o "anterior →".
  const textoAnterior = item.statusAnteriorPorExtenso ?? item.statusAnterior
  const anterior = textoAnterior ? `${textoAnterior} → ` : ''

  return {
    titulo: `${anterior}${item.statusNovoPorExtenso ?? item.statusNovo ?? VAZIO}`,
    autor,
    observacao: item.observacao
  }
}
